<template>
	<div class="card" style="">
		<div :class="cardHeaderClass" v-show="hasCardHeader" class="card-header pt-2 pb-2">
			<div class="d-flex">
				<div :class="headerClass" class="col-4 mr-auto"><span>{{ headerTitle }}</span></div>
				<slot></slot>
				<!--<div>
					<Select2 :options="options" v-model="selected">
						<option disabled value="0">Select one</option>
					</Select2>
				</div>-->
				<form @submit.prevent="search()" v-if="hasSearch" id="search-div" class="input-group col-4">
					<input type="search"
						   v-model="searchCriteria"
						   @keyup.delete="searchOnClear()"
						   class="form-control ds-input"
						   id="search-input" placeholder="Search..."/>
					<div class="input-group-append">
						<input type="submit" value="Go" class="btn btn-outline-primary" id="search-button"/>
					</div>
				</form>
				<div v-if="hasSearch">
					<button @click="emitAdvancedSearch()" class="btn btn-primary ml-3">Advanced Search</button>
				</div>
				<div @click="search()" v-if="hasSearch && advancedSearchCriteria.length > 0">
					<button class="btn btn-primary ml-3">All</button>
				</div>
			</div>
		</div>
		<div class="card-body">
			<div class="table-responsive">
				<div id="dataTable_wrapper" class="dataTables_wrapper dt-bootstrap4">
					<div class="row">
						<div v-if="hasHeader" class="col-sm-12">
							<div :class="entriesClass" class="dataTables_length" id="dataTable_length">
								<label style="margin-right: 0.5em;">Show</label>
								<select
										name="dataTable_length"
										aria-controls="dataTable"
										v-model="privateRowsPerPage"
										@change="updateRowsPerPage()"
								>
									<option v-bind:value="10">10</option>
									<option v-bind:value="25">25</option>
									<option v-bind:value="50">50</option>
									<option v-bind:value="100">100</option>
								</select>
								<label style="margin-left: 0.5em;">entries</label>
							</div>
							<!--<div class="col-sm-12 col-md-6">
								<div id="dataTable_filter" class="dataTables_filter"><label>Search:<input type="search" class="form-control form-control-sm" placeholder="" aria-controls="dataTable" v-model="filterKey"></label>
								</div>
							</div>-->
						</div>
						<div class="col-sm-12">
							<!--<table class="table dataTable table-bordered" width="100%" cellspacing="0">-->
							<table class="table dataTable table-sm table-hover">
								<thead class="">
								<tr>
									<th class="th-icon" v-if="hasLockedColumn"></th>
									<th class="th-icon" v-if="hasDetailColumn"></th>
									<th v-if="!column.locked && !column.hidden"
										class="no-break"
										:class="{
											'text-right': column.align === 'right',
											'text-left': column.align === 'left',
											'text-center': column.align === 'center'
										}"
										@click="sortBy(column.name)"
										v-for="column in columns">
										<span class="pr-1">{{ column.displayName }}</span>
										<font-awesome-icon :icon="getSortFa(column.name)"></font-awesome-icon>
									</th>
									<th class="th-icon" v-if="hasAddColumn"></th>
								</tr>
								</thead>
								<tbody>
								<tr :class="getRowClass(row)" v-for="row in paginatedData">
									<td class="th-icon" v-if="hasLockedColumn">
										<font-awesome-icon v-if="row['Locked']" icon="lock"></font-awesome-icon>
									</td>
									<td class="th-icon" v-if="hasDetailColumn">
										<router-link v-on:toggle-edit-mode="toggleEditMode()"
													 :to="{name: restDetailEntity, params: {id: row.recordId}}">
											<font-awesome-icon icon="eye"></font-awesome-icon>
										</router-link>
									</td>
									<td
											:class="{
												'text-right': column.align === 'right',
												'text-left': column.align === 'left',
												'text-center': column.align === 'center'
											}"
											v-if="!column.locked && !column.hidden"
											v-for="column in columns">
										<span v-if="column.format">{{ row[column.name] | format(column.format) }}</span>
										<span v-else>{{ row[column.name] }}</span>
									</td>
									<td class="th-icon" v-if="hasAddColumn">
										<a href="#" @click.prevent="emitClickPlus(row)">
											<font-awesome-icon icon="plus-circle"></font-awesome-icon>
										</a>
									</td>
								</tr>
								</tbody>
								<!--<tfoot>
								<tr>
									<td></td>
								</tr>
								</tfoot>-->
							</table>
						</div>
					</div>
				</div>
			</div>
			<hr class="h-rule" v-if="hasFooter"/>
			<div v-if="hasFooter" class="row grid-footer">
				<div class="col-md-12 col-lg-5" style="padding-top: 0.5em" :class="entriesClass">
					<span v-if="computedRows.length === 0" role="status"
						  aria-live="polite">
						No Records Found
					</span>
					<span v-if="maxRows > 0" v-else class="dataTables_info" id="dataTable_info" role="status"
						  aria-live="polite">
						Showing
						{{
							rowsPerPage
							* (page - 1) + 1
						}} to {{
							Math.min(rowsPerPage * page,
									maxRows)
						}} of
						{{ maxRows }} entries
					</span>
				</div>
				<nav v-if="computedRows.length > 0" class="col-md-12 col-lg-7">

					<ul class="justify-content-end pagination" :class="paginationClass">
						<li class="paginate_button page-item previous"
							:class="{disabled: page === 1}"
							id="dataTable_previous"><a @click="previousPage()"
													   aria-controls="dataTable"
													   data-dt-idx="0"
													   tabindex="0"
													   class="page-link">Previous</a>
						</li>
						<li v-for="item in gridNavArray(page, navKeyMax)"
							class="paginate_button page-item"
							:class="{active: page === item, disabled: item === '...'}"><a
								@click="goToPage(item)"
								aria-controls="dataTable"
								:data-dt-idx="item"
								tabindex="0"
								class="page-link">{{ item }}</a>
						</li>
						<li class="paginate_button page-item next"
							:class="{disabled: page === navKeyMax}"
							id="dataTable_next"><a
								@click="nextPage()"
								aria-controls="dataTable"
								data-dt-idx="7" tabindex="0"
								class="page-link">Next</a></li>
					</ul>
				</nav>
			</div>
		</div>
		<!--<div class="card-footer">
		</div>-->
	</div>
</template>

<script>
import Select2 from './Select2'

import Vue from 'vue'
import VueMoment from 'vue-moment'
import moment from 'moment'

Vue.use(VueMoment, {
	moment,
});

export default {
	name: "Grid",
	components: {Select2},
	props: {
		components: [Select2],
		columns: {
			type: Array
		},
		rows: {
			type: Array
		},
		page: Number,
		rowsPerPage: Number,
		maxRows: Number,
		hasHeader: {
			type: Boolean,
			default: true
		},
		hasCardHeader: {
			type: Boolean,
			default: true
		},
		hasSearch: {
			type: Boolean,
			default: true
		},
		hasFooter: {
			type: Boolean,
			default: true
		},
		hasDetailColumn: {
			type: Boolean,
			default: true
		},
		hasLockedColumn: {
			type: Boolean,
			default: true
		},
		hasAddColumn: {
			type: Boolean,
			default: false
		},
		entriesClass: {
			type: String
		},
		paginationClass: {
			type: String,
			default: 'pagination'
		},
		headerTitle: String,
		restDetailEntity: String,
		dataKey: {
			type: String,
			default: 'fieldData'
		},
		filterKey: {
			type: String,
			default: ''
		},
		advancedSearchCriteria: Array
	},
	data() {
		return {
			headerClass: 'grid-header',
			cardHeaderClass: '',
			currentSort: '',
			currentSortDir: 'asc',
			sortOrders: {},
			sortFa: 'sort',
			sortKey: '',
			searchCriteria: '',
			privateRowsPerPage: 50,
			selected: 2,
			options: [
				{id: 1, text: 'Hello'},
				{id: 2, text: 'World'}
			]
		}
	},
	computed: {
		computedRows: function () {
			return this.rows.map(row => {
				let newRow = {};
				newRow["recordId"] = row.recordId;
				for (let columnIndex in this.columns) {
					let column = this.columns[columnIndex];
					let fieldDatum = row.fieldData[column["name"]];

					if (column.pk) {
						newRow['PK'] = fieldDatum
					}

					if (column.expired) {
						let expDate = moment(fieldDatum, 'MM/DD/YYYY');
						newRow['AlmostExpired'] = moment().add(60, 'days').isSameOrAfter(expDate);
						newRow['Expired'] = moment().add().isSameOrAfter(expDate)
					}

					if (column.status) {
						newRow['Inactive'] = fieldDatum && fieldDatum.toUpperCase() === 'INACTIVE'
					}

					if (column.locked) {
						newRow['Locked'] = fieldDatum && fieldDatum.toUpperCase() === 'YES'
					} else {
						newRow[column["name"]] = fieldDatum
					}
				}
				return newRow
			})
		},
		navKeyMax: function () {
			return Math.ceil(this.maxRows / this.rowsPerPage)
		},
		paginatedData: function () {
			return this.filteredData
		},
		filteredData: function () {
			// let sortKey = this.sortKey
			// let filterKey = this.filterKey && this.filterKey.toLowerCase()
			// let order = this.sortOrders[sortKey] || 1
			let data = this.computedRows;
			// if (sortKey) {
			data = data.slice().sort((a, b) => {
				let modifier = 1;
				if (this.currentSortDir === 'desc') modifier = -1;
				if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
				if (a[this.currentSort] > b[this.currentSort]) return modifier;
				return 0;
			});
			/*data = data.slice().sort(function (a, b) {
      a = a[sortKey]
      b = b[sortKey]
      return (a === b ? 0 : a > b ? 1 : -1) * order
    })*/
			// }
			/*if (filterKey) {
                data = data.filter(function (row) {
                    return Object.keys(row.fieldData).some(function (key) {
                        return String(row.fieldData[key]).toLowerCase().indexOf(filterKey) > -1
                    })
                })
            }*/
			return data
		}
	},
	methods: {
		searchOnClear: function () {
			if (this.searchCriteria === '') {
				this.search()
			}
		},
		emitClickPlus: function (row) {
			this.$emit('click-plus', {
				id: row.recordId,
				pk: row.PK
			})
		},
		search: function () {
			this.goToPage(1, true)
		},
		updateRowsPerPage: function () {
			let limit = this.privateRowsPerPage;
			let quickFind;
			if (!this.advancedSearchCriteria && !this.searchCriteria()) {
				quickFind = true
			} else {
				quickFind = this.advancedSearchCriteria.length === 0
			}
			this.$emit('update-rows-per-page', {
				limit: limit,
				page: 1,
				searchCriteria: quickFind ? this.searchCriteria : this.advancedSearchCriteria,
				quickFind: quickFind
			})
		},
		goToPage: function (page, quickFind = false) {
			let limit = this.rowsPerPage;
			let offset = limit * (page - 1);

			if (quickFind === false) {
				if (!this.advancedSearchCriteria && !this.searchCriteria()) {
					quickFind = true
				} else {
					quickFind = this.advancedSearchCriteria.length === 0
				}
			}

			this.$emit('goto-page', {
				limit: limit,
				offset: offset,
				page: page,
				searchCriteria: quickFind ? this.searchCriteria : this.advancedSearchCriteria,
				quickFind: quickFind
			})
		},
		previousPage: function () {
			if (this.page > 1) {
				this.goToPage(this.page - 1)
			}
		},
		nextPage: function () {
			if (this.page < this.navKeyMax) {
				this.goToPage(this.page + 1)
			}
		},
		gridNavArray: (current, last) => {
			let delta = 2;
			let left = current - delta;
			let right = current + delta + 1;
			let range = [];
			let rangeWithDots = [];
			let l;

			for (let i = 1; i <= last; i++) {
				if (i === 1 || i === last || (i >= left && i < right)) {
					range.push(i)
				}
			}

			for (let i of range) {
				if (l) {
					if (i - l === 2) {
						rangeWithDots.push(l + 1)
					} else if (i - l !== 1) {
						rangeWithDots.push('...')
					}
				}
				rangeWithDots.push(i);
				l = i
			}

			return rangeWithDots
		},
		sortBy: function (s) {
			//if s == current sort, reverse
			if (s === this.currentSort) {
				this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
			}
			this.currentSort = s;
		},
		getRowClass: function (row) {
			if (row['Expired'] === true) {
				return 'expired'
			} else if (row['AlmostExpired'] === true) {
				return 'almost-expired'
			} else {
				return ''
			}
		},
		getSortFa: function (key) {
			let myClass;
			if (this.currentSort !== key) {
				myClass = 'sort'
			} else if (this.currentSortDir === 'desc') {
				myClass = 'sort-down'
			} else {
				myClass = 'sort-up'
			}
			return myClass
		},
		emitAdvancedSearch: function () {
			this.$emit('advanced-search')
		}
	},
	mounted: function () {
		let vm = this;
		if (this.columns !== undefined) {
			this.columns.forEach(function (key) {
				vm.sortOrders[key.name] = 1
			})
		}
	}
}
</script>

<style scoped>
/*.table tbody tr:last-child td, .table tbody tr:last-child th {
border-bottom: 1px solid #dee2e6;
}*/

table.dataTable {
    clear: both;
    margin-top: 6px !important;
    margin-bottom: 6px !important;
    max-width: none !important;
    border-collapse: separate !important;
    border-spacing: 0;
}

table.dataTable td,
table.dataTable th {
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
}

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
    text-align: center;
}

table.dataTable.nowrap th,
table.dataTable.nowrap td {
    white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length label {
    font-weight: normal;
    text-align: left;
    white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length select {
    width: auto;
    display: inline-block;
}

div.dataTables_wrapper div.dataTables_filter {
    text-align: right;
}

div.dataTables_wrapper div.dataTables_filter label {
    font-weight: normal;
    white-space: nowrap;
    text-align: left;
}

div.dataTables_wrapper div.dataTables_filter input {
    margin-left: 0.5em;
    display: inline-block;
    width: auto;
}

div.dataTables_wrapper div.dataTables_info {
    padding-top: 0.85em;
    white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_paginate {
    margin: 0;
    white-space: nowrap;
    text-align: right;
}

div.dataTables_wrapper div.dataTables_paginate ul.pagination {
    margin: 2px 0;
    white-space: nowrap;
    justify-content: flex-end;
}

div.dataTables_wrapper div.dataTables_processing {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 200px;
    margin-left: -100px;
    margin-top: -26px;
    text-align: center;
    padding: 1em 0;
}

table.dataTable thead > tr > th.sorting_asc, table.dataTable thead > tr > th.sorting_desc, table.dataTable thead > tr > th.sorting,
table.dataTable thead > tr > td.sorting_asc,
table.dataTable thead > tr > td.sorting_desc,
table.dataTable thead > tr > td.sorting {
    padding-right: 30px;
}

table.dataTable thead > tr > th:active,
table.dataTable thead > tr > td:active {
    outline: none;
}

table.dataTable thead .sorting,
table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc,
table.dataTable thead .sorting_asc_disabled,
table.dataTable thead .sorting_desc_disabled {
    cursor: pointer;
    position: relative;
}

table.dataTable thead .sorting:before, table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:before,
table.dataTable thead .sorting_desc_disabled:after {
    position: absolute;
    bottom: 0.9em;
    display: block;
    opacity: 0.3;
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc_disabled:before {
    right: 1em;
    content: "\2191";
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
    right: 0.5em;
    content: "\2193";
}

table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:after {
    opacity: 1;
}

table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc_disabled:after {
    opacity: 0;
}

div.dataTables_scrollHead table.dataTable {
    margin-bottom: 0 !important;
}

div.dataTables_scrollBody table {
    border-top: none;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
}

div.dataTables_scrollBody table thead .sorting:before,
div.dataTables_scrollBody table thead .sorting_asc:before,
div.dataTables_scrollBody table thead .sorting_desc:before,
div.dataTables_scrollBody table thead .sorting:after,
div.dataTables_scrollBody table thead .sorting_asc:after,
div.dataTables_scrollBody table thead .sorting_desc:after {
    display: none;
}

div.dataTables_scrollBody table tbody tr:first-child th,
div.dataTables_scrollBody table tbody tr:first-child td {
    border-top: none;
}

div.dataTables_scrollFoot > .dataTables_scrollFootInner {
    box-sizing: content-box;
}

div.dataTables_scrollFoot > .dataTables_scrollFootInner > table {
    margin-top: 0 !important;
    border-top: none;
}

@media screen and (max-width: 767px) {
    div.dataTables_wrapper div.dataTables_length,
    div.dataTables_wrapper div.dataTables_filter,
    div.dataTables_wrapper div.dataTables_info,
    div.dataTables_wrapper div.dataTables_paginate {
        text-align: center;
    }
}

table.dataTable.table-sm > thead > tr > th {
    padding-right: 20px;
}

table.dataTable.table-sm .sorting:before,
table.dataTable.table-sm .sorting_asc:before,
table.dataTable.table-sm .sorting_desc:before {
    top: 5px;
    right: 0.85em;
}

table.dataTable.table-sm .sorting:after,
table.dataTable.table-sm .sorting_asc:after,
table.dataTable.table-sm .sorting_desc:after {
    top: 5px;
}

table.table-bordered.dataTable th,
table.table-bordered.dataTable td {
    border-left-width: 0;
}

table.table-bordered.dataTable th:last-child, table.table-bordered.dataTable th:last-child,
table.table-bordered.dataTable td:last-child,
table.table-bordered.dataTable td:last-child {
    border-right-width: 0;
}

table.table-bordered.dataTable tbody th,
table.table-bordered.dataTable tbody td {
    border-bottom-width: 0;
}

div.dataTables_scrollHead table.table-bordered {
    border-bottom-width: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row {
    margin: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^="col-"]:first-child {
    padding-left: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^="col-"]:last-child {
    padding-right: 0;
}

td, th {
    font-size: smaller;
}

div.table-footer {
    width: 100%;
}

.no-break {
    white-space: nowrap;
}

div.card-footer {
    padding-bottom: 0 !important;
}

tr.expired > td {
    opacity: 0.5 !important;
}

tr.almost-expired > td {
    color: darkred;
}

.container-fluid {
    padding-right: 4em;
}

.th-icon {
    width: 16px;
    padding-right: 0.5em !important;
}

.text-small {
    font-size: small;
}

.h-rule {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
}

.card-body {
    padding-bottom: 0;
}

.pagination {
    margin-bottom: 0;
}

.grid-footer {
    padding-bottom: 0.5em;
}

.grid-header {
    padding-top: 0.5em;
}

</style>